var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rowData.invoice_url)?_c('a',{attrs:{"href":_vm.rowData.invoice_url,"target":"_blank"}},[_c('i',{staticClass:"fa fa-money"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }